// extracted by mini-css-extract-plugin
export var card = "_a0-0";
export var failedIcon = "_a0-4";
export var failedIconBadge = "_a0-3";
export var icon = "_a0-1";
export var successIcon = "_a0-2";